import { gql } from "@apollo/client";

export const GET_STATISTICS_DIPLOMAS = gql`
  query StatisticsDiplomas($from: Date, $to: Date, $groupBy: String) {
    certStatisticsDiplomas(from: $from, to: $to, groupBy: $groupBy) {
      data
      createdAt
    }
  }
`;
export const GET_STATISTICS_CERTIFICATES = gql`
  query StatisticsCetificates($from: Date, $to: Date, $groupBy: String) {
    certStatisticsCertificates(from: $from, to: $to, groupBy: $groupBy) {
      data
      createdAt
    }
  }
`;
export const GET_STATISTICS_TUTOR_CERTIFICATES = gql`
  query StatisticsTutorCetificates($from: Date, $to: Date, $groupBy: String) {
    certStatisticsTutorCertificates(from: $from, to: $to, groupBy: $groupBy) {
      data
      createdAt
    }
  }
`;
export const GET_STATISTICS_CARE_ASSISTANT_DIPLOMAS = gql`
  query StatisticsCareAssistantDiplomas(
    $from: Date
    $to: Date
    $groupBy: String
  ) {
    certStatisticsCareAssistantDiplomas(
      from: $from
      to: $to
      groupBy: $groupBy
    ) {
      data
      createdAt
    }
  }
`;

export const GET_STATISTICS_AMBASSADOR_CERTIFICATES = gql`
  query StatisticsAmbassadorCertificates(
    $from: Date
    $to: Date
    $groupBy: String
  ) {
    certStatisticsAmbassadorCertificates(
      from: $from
      to: $to
      groupBy: $groupBy
    ) {
      data
      createdAt
    }
  }
`;

export const GET_STATISTICS_LANGUAGE_REPRESENTATIVE_DIPLOMAS = gql`
  query StatisticsLanguageRepresentativeDiplomas(
    $from: Date
    $to: Date
    $groupBy: String
  ) {
    certStatisticsLanguageRepresentativeDiplomas(
      from: $from
      to: $to
      groupBy: $groupBy
    ) {
      data
      createdAt
    }
    certStatisticsLanguageRepresentativeDiplomasNoCollege: certStatisticsLanguageRepresentativeDiplomas(
      from: $from
      to: $to
      groupBy: null
    ) {
      data
      createdAt
    }
  }
`;

export const GET_STATISTICS_LANGUAGE_REPRESENTATIVE_EDUCATOR_DIPLOMAS = gql`
  query StatisticsLanguageRepresentativeEducatorDiplomas(
    $from: Date
    $to: Date
  ) {
    certStatisticsLanguageRepresentativeEducatorDiplomas(from: $from, to: $to) {
      data
      createdAt
    }
  }
`;

export const GET_STATISTICS_COURSE_MOMENTS = gql`
  query StatisticsCourseMoments($from: Date, $to: Date) {
    certStatisticsCourseMoments(from: $from, to: $to) {
      data
      createdAt
    }
  }
`;
